<template>
    <div class="user_descriptions">
        <div class="user_descr">
            <info_field
                :is_disabled="this.is_disabled"
                f_uniq="ctgk"
                f_type="google_key"
                @update_categ="change_atr"
                :f_title="__t('GOOGLE_KEY')"
                :f_val=pwa.google_key>
            </info_field>
        </div>
    </div>
</template>

<script>
import info_field from "../../../../../sys/info_field";

export default {
    name: "g_map",
    components : {
        info_field,
    },
    props : {
        pwa : {
            type:Object
        }
    },
    methods : {
        change_atr(atr_name,atr_val) {
            if(this.pwa.hasOwnProperty(atr_name)) {
                this.pwa[atr_name] = atr_val;
            }
        }
    },

    computed : {

        is_disabled() {
            return false;
        },
    }
}
</script>

<style scoped>

</style>
